import { TrackingEvent } from 'client/tracking/event';
import { CommonMap } from 'client/tracking/maps/common';
import { TrackingConstant } from 'client/tracking/constant';
import { generateTrackingIds } from 'site-modules/shared/utils/make-model-zip';
import { getSearchByModuleTrackingMap } from 'client/tracking/maps/common/search-by-module';
import { AppraisalTabsMap } from 'client/tracking/maps/appraisal/common/appraisal-tabs';

const PAGE_NAME = 'used_cars_index';
export const MMZ_TRACKING_IDS = generateTrackingIds(PAGE_NAME, 'mmz');

export const TOP_LINKS_TRACKING_MAP = {
  id: {
    'Car Appraiser': `${PAGE_NAME}_appraise_vehicle_click`,
    'Sell My Car': `${PAGE_NAME}_appraise_vehicle_click`,
    'Certified Pre-owned Cars': `${PAGE_NAME}_certified_cars_click`,
    'Affordability Calculator': `${PAGE_NAME}_affordability_calculator_click`,
    'Loan Calculator': `${PAGE_NAME}_car_loan_calculator_click`,
    'Buy Online': 'link_select_tool_select',
  },
};

const map = {
  [MMZ_TRACKING_IDS.makeSelectTrackingId]: TrackingEvent.actionStart(
    TrackingConstant.ACTION_MMZ_SELECT,
    TrackingConstant.MAKE_SELECT
  ),

  [MMZ_TRACKING_IDS.modelSelectTrackingId]: TrackingEvent.actionProgress(
    TrackingConstant.ACTION_MMZ_SELECT,
    TrackingConstant.MODEL_SELECT
  ),

  [MMZ_TRACKING_IDS.submitTrackingId]: TrackingEvent.actionEnd(
    TrackingConstant.ACTION_MMZ_SELECT,
    TrackingConstant.SUBMIT_MMZ
  ),

  [TOP_LINKS_TRACKING_MAP.id['Car Appraiser']]: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.ACTION_APPRAISE_VEHICLE
  ),

  [TOP_LINKS_TRACKING_MAP.id['Certified Pre-owned Cars']]: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.CERTIFIED_CARS
  ),

  [TOP_LINKS_TRACKING_MAP.id['Affordability Calculator']]: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.AFFORDABILITY_CALCULATOR
  ),

  [TOP_LINKS_TRACKING_MAP.id['Loan Calculator']]: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.CAR_LOAN_CALCULATOR
  ),

  search_vehicles: TrackingEvent.actionEnd(TrackingConstant.VIEW_SEARCH_RESULT, TrackingConstant.SEARCH_PERKS),

  appraise_your_car: TrackingEvent.actionCompleted(
    TrackingConstant.ACTION_TOOL_SELECT,
    TrackingConstant.APPRAISE_YOUR_CAR
  ),

  ...getSearchByModuleTrackingMap(MMZ_TRACKING_IDS),
};

export const TrackingMap = {
  ...CommonMap,
  ...AppraisalTabsMap,
  ...map,
};
